import React from 'react';
import { motion } from 'framer-motion';
import { COURSES } from '../data/mockData';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Courses = () => {
  const { t, language } = useLanguage();

  return (
    <div className="pt-32 pb-24 min-h-screen bg-secondary/30">
      <div className="container mx-auto px-6 md:px-12">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="text-center max-w-3xl mx-auto mb-20">
          <h1 className="font-serif text-5xl mb-6">{t('courses.title')} <br/>{t('courses.titleSuffix')}</h1>
          <p className="text-text-light leading-relaxed">
            {t('courses.description')}
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {COURSES.map((course, index) => (
            <motion.div key={course.id} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.2, duration: 0.6 }} className="bg-white shadow-soft group flex flex-col h-full">
              <div className="h-64 overflow-hidden relative">
                <img src={course.image} alt={course.title[language]} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute top-4 left-4 bg-white/90 px-3 py-1 text-xs uppercase tracking-widest font-semibold">{course.level[language]}</div>
              </div>
              <div className="p-8 flex flex-col flex-grow">
                <div className="flex justify-between items-center mb-4 text-xs text-text-light uppercase tracking-widest">
                  <span>{course.duration[language]}</span>
                </div>
                <h3 className="font-serif text-2xl mb-4">{course.title[language]}</h3>
                <p className="text-text-light text-sm mb-8 flex-grow">{course.description[language]}</p>
                <Link to={`/courses/${course.id}`} className="block w-full py-4 border border-text-dark text-center uppercase tracking-widest text-sm hover:bg-text-dark hover:text-white transition-colors">
                  {t('courses.viewCourseDetails')}
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Courses;
